import { Injectable } from '@angular/core';
import { UserState, initialState } from '../store/User/UserReducer';

@Injectable({
  providedIn: 'root',
})
export class UserStatePersistenceService {
  private readonly STORAGE_KEY = 'clearing_web_user_state';

  saveState(state: UserState): void {
    try {
      const serializedState = JSON.stringify(state);
      localStorage.setItem(this.STORAGE_KEY, serializedState);
    } catch (error) {
      console.error('Failed to save user state to localStorage:', error);
    }
  }

  loadState(): UserState {
    try {
      const serializedState = localStorage.getItem(this.STORAGE_KEY);
      if (serializedState === null) {
        return initialState;
      }

      const parsedState = JSON.parse(serializedState) as UserState;

      if (this.isValidUserState(parsedState)) {
        return parsedState;
      } else {
        console.warn(
          'Invalid user state structure in localStorage, using initial state',
        );
        this.clearState();
        return initialState;
      }
    } catch (error) {
      console.error('Failed to load user state from localStorage:', error);
      this.clearState();
      return initialState;
    }
  }

  clearState(): void {
    try {
      localStorage.removeItem(this.STORAGE_KEY);
    } catch (error) {
      console.error('Failed to clear user state from localStorage:', error);
    }
  }

  private isValidUserState(state: any): state is UserState {
    return (
      state &&
      typeof state === 'object' &&
      typeof state.isAuthenticated === 'boolean' &&
      (state.user === null || typeof state.user === 'object') &&
      (state.selectedAccount === null ||
        typeof state.selectedAccount === 'string') &&
      (state.csrfToken === null || typeof state.csrfToken === 'string') &&
      (state.csrfParameterName === null ||
        typeof state.csrfParameterName === 'string')
    );
  }
}
